export default __webpack_public_path__ + "static/media/investBullet.e4f3de98.svg";